import { render, staticRenderFns } from "./render-phone-column-value.vue?vue&type=template&id=450c2534"
import script from "./render-phone-column-value.vue?vue&type=script&lang=js"
export * from "./render-phone-column-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450c2534')) {
      api.createRecord('450c2534', component.options)
    } else {
      api.reload('450c2534', component.options)
    }
    module.hot.accept("./render-phone-column-value.vue?vue&type=template&id=450c2534", function () {
      api.rerender('450c2534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-phone-column-value.vue"
export default component.exports